import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { OidcClient } from '@pingidentity-developers-experience/ping-oidc-client-sdk';
import { pingIdConfig } from '../../config/pingIdConfig';
import ErrorPage from "../ErrorMessage/ErrorPage";

function PingIdLogin() {
    const [oidcClient, setOidcClient] = useState(null);
    const [loginError, setLoginError] = useState(false);

    const search = useLocation().search;
    const activeStore = new URLSearchParams(search).get("storeId");
    const name = new URLSearchParams(search).get("source");
    const pingError = new URLSearchParams(search).get("error");
    const pingErrorDesc = new URLSearchParams(search).get("error_description");

    if (activeStore || activeStore === "") {
        localStorage.setItem("source", "wow-crew");
        localStorage.setItem("storeId", activeStore);
    } else {
        localStorage.setItem("storeId", "");
        if (name) {
            localStorage.setItem("source", name);
        } else {
            localStorage.setItem("source", "");
        }
    }

    useEffect(() => {
        const initializeClient = async () => {
            try {
                const client = await OidcClient.initializeFromOpenIdConfig(process.env.REACT_APP_PINGONE_AUTH_URL, pingIdConfig);
                setOidcClient(client);
            } catch (error) {
                console.error('Error initializing OIDC client:', error);
                if (!pingError) {
                    setLoginError(true);
                }
            }
        };

        const fetchUserDetails = async () => {
            try {
                if (!oidcClient) {
                    throw new Error('OIDC client is not initialized');
                }

                if (await oidcClient.hasToken()) {
                    let tokenDetails, userInfoDetails;
                    try {
                        tokenDetails = await oidcClient.getToken();
                        userInfoDetails = await oidcClient.fetchUserInfo();
                    } catch (error) {
                        console.warn('Stale token detected, re-initiating auth flow:', error);
                        try {
                            await oidcClient.revokeToken();
                        } catch (revokeError) {
                            console.warn('Token revocation failed (may already be expired):', revokeError);
                        }
                        localStorage.removeItem('response');
                        localStorage.removeItem('jwtToken');
                        oidcClient.authorize();
                        return;
                    }

                    const tempResponse = {
                        "idToken": tokenDetails.access_token,
                        "accessToken": tokenDetails.access_token,
                        "tokenType": "Bearer",
                        "account": {
                            "idTokenClaims": {
                                "employeeId": userInfoDetails.employeeId,
                                "adupn": userInfoDetails.adupn,
                                "name": userInfoDetails.name,
                                "isCorpUser": userInfoDetails.isCorpUser ? userInfoDetails.isCorpUser : true
                            }
                        }
                    };

                    localStorage.setItem('response', JSON.stringify(tempResponse));
                    globalThis.location.replace("/summary");
                } else {
                    oidcClient.authorize();
                }
            } catch (error) {
                console.error('Error fetching user details:', error);
                if (!pingError) {
                    setLoginError(true);
                }
            }
        };

        if (oidcClient) {
            fetchUserDetails();
        } else {
            initializeClient();
        }

    }, [oidcClient, pingError]);

    return (
        <div>
            {pingError || loginError ? (
                <ErrorPage error={pingError ? `${pingError} - ${pingErrorDesc}` : "Ping login failed. Please try again later."} />
            ) : (
                <div />
            )}
        </div>
    );
};

export default PingIdLogin;